<template>
	<!-- A heading per reserve type, aligned rows, quantity on the right, full text on hover -->
	<div class="reserves-grouped">
		<div v-for="group in groups" :key="group.type" class="reserve-group">
			<div class="reserve-group-header">
				<i :class="['cci', typeIcon(group.type)]" aria-hidden="true"></i>
				<span>{{ group.type }}</span>
				<span class="reserve-group-rule"></span>
			</div>
			<div v-for="item in group.items" :key="item.name" class="grouped-row" v-tip="tip(item)">
				<span class="grouped-name">{{ item.name }}</span>
				<span v-if="item.callsign" class="reserve-owner-tag">{{ item.callsign }}</span>
				<span v-if="item.count" class="reserve-count-pill">×{{ item.count }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import { stripHtml } from "@/utils/lancerInfo";

const ICONS = {
	tactical: "cci-reserve-tactical",
	mech: "cci-reserve-mech",
	resource: "cci-reserve-resource",
	bonus: "cci-reserve-bonus",
	exotic: "cci-trait",
};
const TYPE_ORDER = ["Tactical", "Mech", "Resource", "Bonus", "Exotic"];

export default {
	props: {
		reserves: { type: Array, required: true },
	},
	computed: {
		groups() {
			const byType = {};
			this.reserves.forEach(item => (byType[item.type] = byType[item.type] || []).push(item));
			const rank = type =>
				TYPE_ORDER.includes(type) ? TYPE_ORDER.indexOf(type) : TYPE_ORDER.length;
			return Object.keys(byType)
				.sort((a, b) => rank(a) - rank(b) || a.localeCompare(b))
				.map(type => ({ type, items: byType[type] }));
		},
	},
	methods: {
		tip(item) {
			const body = stripHtml(item.description).replace(/\*\*|__|#+\s/g, "");
			const owner = item.callsign ? `\n\nHeld by ${item.callsign}` : "";
			return { title: `${item.name}${item.count ? ` ×${item.count}` : ""}`, body: body + owner };
		},
		typeIcon(type) {
			return ICONS[String(type).toLowerCase()] || "cci-generic-item";
		},
	},
};
</script>

<style scoped>
.reserves-grouped {
	height: 100%;
	overflow: auto;
	padding: 0.4em 0 0.8em;
}

.reserve-group-header {
	display: flex;
	align-items: center;
	gap: 0.5em;
	padding: 0.8em 1em 0.3em;
	font-family: "Raleway", sans-serif;
	font-size: 10px;
	font-weight: 800;
	letter-spacing: 3px;
	text-transform: uppercase;
	color: #b8973a;
}

.reserve-group-header .cci {
	font-size: 16px;
}

.reserve-group-rule {
	flex: 1;
	height: 1px;
	background: rgba(184, 151, 58, 0.25);
}

.grouped-row {
	display: flex;
	align-items: center;
	gap: 0.6em;
	padding: 0.35em 1em 0.35em 2.2em;
	cursor: help;
	transition: background-color 0.15s;
}

.grouped-row:hover {
	background: rgba(184, 151, 58, 0.1);
}

.grouped-name {
	flex: 1;
	min-width: 0;
	font-family: "Titillium Web", sans-serif;
	font-size: 15px;
	color: var(--text-location);
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.reserve-owner-tag {
	font-family: "Share Tech Mono", monospace;
	font-size: 10px;
	letter-spacing: 0.08em;
	color: var(--text-pilot-code);
	text-transform: uppercase;
}

.reserve-count-pill {
	flex-shrink: 0;
	padding: 0 0.45em;
	border-radius: 2px;
	background: rgba(184, 151, 58, 0.18);
	border: 1px solid rgba(184, 151, 58, 0.5);
	font-family: "Share Tech Mono", monospace;
	font-size: 11px;
	color: #b8973a;
}
</style>
